import * as React  from 'react'
import ImageGallery from 'react-image-gallery'
import parse from 'html-react-parser'
import { useTranslation } from 'react-i18next'
import { Blockquote, Button,  Text } from '@radix-ui/themes'

import { INDEX_I18NEXT } from '~/routes/($lang)._index/index.component'


const Gallery: React.FC = () => {
  const { t } = useTranslation(INDEX_I18NEXT.routeIndex)

  const images = []

  for (let i = 1; i < 40; i++) {
    images.push({
      original: `/pwa/img/compress/gallery/img_${i}.webp`,
      thumbnail: `/pwa/img/compress/gallery/img_${i}_small.webp`,
      loading: 'lazy',
      thumbnailLoading: 'lazy',
      originalHeight: 800,
      thumbnailHeight: 100,
      originalClass: 'item original',
      thumbnailClass: 'item thumbnail',
    })
  }

  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex justify-start">
        <Blockquote className="flex flex-col gap-y-4 max-w-xl">
          <Text color="gray" className="text-justify">
            {parse(t('common.gallery.description'))}
          </Text>
          <div className="inline-flex">
            <Button variant="outline">
              <a
                href="https://www.google.de/search?q=M%26A+Solar+Rezensionen&sca_esv=585329697&biw=2560&bih=1327&ei=h6BiZeCfM628xc8Pp6S72AY&ved=0ahUKEwig_4LwwuCCAxUtXvEDHSfSDmsQ4dUDCGs&uact=5&oq=M%26A+Solar+Rezensionen&gs_lp=Egxnd3Mtd2l6LXNlcnAiFU0mQSBTb2xhciBSZXplbnNpb25lbjIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwAzIKEAAYRxjWBBiwA0i5CVAAWABwAXgBkAEAmAEAoAEAqgEAuAEDyAEA4gMEGAAgQYgGAZAGBw&sclient=gws-wiz-serp#lrd=0x47aff7498b42c645:0xa411ddba69b1d920,1,,,,"
                target="_blank"
                rel="noreferrer"
              >
                {t('common.gallery.reviews')}
              </a>
            </Button>
          </div>
        </Blockquote>
      </div>
      <div className="overflow-hidden app-Gallery">
        <ImageGallery items={images} />
      </div>
    </div>
  )
}


export { Gallery }
